module.exports = __webpack_public_path__ + "media/images/icons/country_flags/zw-735c39ede075ea451822bf9483c66d83.svg";